import React, { useState, useMemo } from "react";
import { LinearProgress } from "@material-ui/core";

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, TableRow, Table, TableHead, TableBody, TableContainer, Paper, Checkbox, CircularProgress, TableCell, IconButton } from "@material-ui/core";
import TablePagination from '@material-ui/core/TablePagination';

import StudentService from "./Locality/Service/studentService";
import FeeService from "./Locality/Service/feeService";
import AcademicYearService from "./Locality/Service/academicYearService";

import * as Yup from 'yup';

import FormControlLabel from '@material-ui/core/FormControlLabel';

import { Grid, Card, Box, Select, TextField } from "@material-ui/core";
import SchoolDatePicker from "../../components/SchoolDatePicker/SchoolDatePicker";
import { useFormik } from 'formik';

import { useEffect } from 'react';

import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ScheduleIcon from '@material-ui/icons/Schedule';
import { Add, Remove } from "@material-ui/icons";
import Widget from "../../components/Widget/Widget";
import { Typography } from "../../components/Wrappers/Wrappers";

import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
const normalizeInstallmentStatus = (status) =>
    String(status || "").toLowerCase() === "paid" ? "Paid" : "Due";

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    statusInstructionCard: {
        display: 'flex',
        gap: 14,
        alignItems: 'flex-start',
        padding: '14px 18px',
        marginBottom: 16,
        borderRadius: 10,
        background: 'linear-gradient(135deg, #f0f7fc 0%, #e8f1f8 100%)',
        border: '1px solid #c5d9ea',
        boxShadow: '0 1px 3px rgba(15, 59, 98, 0.06)',
        [theme.breakpoints.down('xs')]: {
            gap: 10,
            padding: '12px',
        },
    },
    pageHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 12,
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(4),
        [theme.breakpoints.down('xs')]: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },
    },
    pageHeaderTitle: {
        color: theme.palette.text.hint,
    },
    pageHeaderButton: {
        textTransform: 'none',
        whiteSpace: 'nowrap',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    // Wide fee table scrolls sideways on small screens instead of squeezing columns.
    tableOverflow: {
        overflowX: 'auto',
    },
    statusInstructionIconWrap: {
        flexShrink: 0,
        width: 40,
        height: 40,
        borderRadius: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#0f3b62',
        color: '#fff',
    },
    statusBadgeDue: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '2px 8px',
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 700,
        backgroundColor: '#fee2e2',
        color: '#b91c1c',
        verticalAlign: 'middle',
    },
    statusBadgePaid: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '2px 8px',
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 700,
        backgroundColor: '#dcfce7',
        color: '#15803d',
        verticalAlign: 'middle',
    },
    parentAppHint: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        marginTop: 8,
        padding: '6px 10px',
        borderRadius: 8,
        backgroundColor: 'rgba(15, 59, 98, 0.08)',
        color: '#0f3b62',
        fontSize: 12,
        fontWeight: 600,
    },
    deleteDialogPaper: {
        borderRadius: 14,
        width: 480,
        maxWidth: '95vw',
    },
    deleteDialogTitleBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 2.5),
        borderBottom: '1px solid #eef1f5',
    },
    deleteDialogTitleText: {
        fontWeight: 700,
        fontSize: '1.15rem',
        color: '#0f2d4d',
    },
    deleteDialogBody: {
        padding: theme.spacing(2.5),
    },
    deleteDialogFooter: {
        padding: theme.spacing(1.5, 2.5),
        borderTop: '1px solid #eef1f5',
    },
    deleteCancelBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        color: '#46566b',
    },
    deleteConfirmBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        backgroundColor: '#c62828',
        color: '#fff',
        '&:hover': { backgroundColor: '#b71c1c' },
    },
    deleteConfirmText: {
        color: '#46566b',
        fontSize: '0.9rem',
        lineHeight: 1.6,
    },
}));
// Helper function to get ordinal suffix for numbers
const getOrdinalSuffix = (num) => {
    const j = num % 10;
    const k = num % 100;
    if (j === 1 && k !== 11) return 'st';
    if (j === 2 && k !== 12) return 'nd';
    if (j === 3 && k !== 13) return 'rd';
    return 'th';
};

const normalizeFeeRefId = (value) => {
    const id = value?._id ?? value;
    return id && String(id).trim() !== "" ? String(id) : "";
};

const normalizeFeeSectionId = (sectionId) => {
    const id = sectionId?._id ?? sectionId;
    return id && String(id).trim() !== "" ? String(id) : "";
};

/**
 * Class-wise / section-wise (`isEventForAllStudent`) fees cannot be added twice
 * for the same academic year + class. Class-wide and section-specific also block each other.
 */
const getClassSectionWiseDuplicateMessage = (existingFees, { academicYearId, classId, sectionId, excludeId }) => {
    const year = normalizeFeeRefId(academicYearId);
    const cls = normalizeFeeRefId(classId);
    const section = normalizeFeeSectionId(sectionId);
    const exclude = normalizeFeeRefId(excludeId);
    if (!year || !cls) return null;

    const scoped = (existingFees || []).filter((feeRow) => {
        if (!feeRow?.isEventForAllStudent) return false;
        if (exclude && normalizeFeeRefId(feeRow._id) === exclude) return false;
        if (normalizeFeeRefId(feeRow.academicYearId) !== year) return false;
        if (normalizeFeeRefId(feeRow.classId) !== cls) return false;
        return true;
    });

    if (scoped.length === 0) return null;

    const hasClassWide = scoped.some((f) => !normalizeFeeSectionId(f.sectionId));
    const hasThisSection = section
        ? scoped.some((f) => normalizeFeeSectionId(f.sectionId) === section)
        : false;
    const hasAnySection = scoped.some((f) => !!normalizeFeeSectionId(f.sectionId));

    if (!section) {
        if (hasClassWide) {
            return "Class-wise fee data already exists for this class and academic year. You cannot add it again.";
        }
        if (hasAnySection) {
            return "Section-wise fee data already exists for this class. Remove those first before adding a class-wise fee.";
        }
    } else {
        if (hasClassWide) {
            return "Class-wise fee data already exists for this class and academic year. You cannot add section-wise fees.";
        }
        if (hasThisSection) {
            return "Section-wise fee data already exists for this section and academic year. You cannot add it again.";
        }
    }
    return null;
};

export default function Fee() {
    const tableHeaders = ['Academic Year', 'Class', 'Section', 'Student Name', 'Total Fee', 'Additional Components', 'Installment Fee', 'Action'];

    const classes = useStyles();
    const theme = useTheme();
    const isPhone = useMediaQuery(theme.breakpoints.down('xs'));
    const [teacherList, setTeacherList] = useState([]);
    const [classNameList, setClassNameList] = useState([]);
    const [addClassList, setAddClassList] = useState([]);

    const [age, setAge] = React.useState('');
    const [studentList, setStudentList] = useState([]);
    var [error, setError] = useState(null);
    const [teacherIdList, setTeacherIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(1000);
    const [feeList, setFeeList] = useState([]);
    const [academicYearList, setAcademicYearList] = useState([]);
    const [filterClassId, setFilterClassId] = useState("");
    const [filterSectionId, setFilterSectionId] = useState("");
    const [filterStudentId, setFilterStudentId] = useState("");
    const [filterSectionList, setFilterSectionList] = useState([]);
    const [filterStudentList, setFilterStudentList] = useState([]);
    const [formSectionList, setFormSectionList] = useState([]);
    const [updatingInstallmentId, setUpdatingInstallmentId] = useState(null);
    const [deleteConfirm, setDeleteConfirm] = useState({ open: false, row: null });
    const [deleteLoading, setDeleteLoading] = useState(false);

    const [fee, setFee] = useState({
        academicYearId: "",
        classId: "",
        sectionId: "",
        studentId: [],
        isEventForAllStudent: false,
        totalFee: "",
        tuitionFee: "",
        transportationFee: "",
        foodFee: "",
        appFee: "",
        feeComponents: [],
        installments: [{ fee: "", date: "" }],
    })
    const [savedInstallments, setSavedInstallments] = useState([]);
    const [installments, setInstallments] = useState([
        { fee: "", date: "" },
    ]);
    const [feeComponents, setFeeComponents] = useState([
        { name: "", fee: "" },
    ]);

    const toNumber = (v) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
    };

    const computeTotalFee = (values, components) => {
        const base =
            toNumber(values.tuitionFee) +
            toNumber(values.transportationFee) +
            toNumber(values.foodFee) +
            toNumber(values.appFee);
        // Fee components: positive adds, negative subtracts
        const extra = (components || []).reduce((sum, row) => sum + toNumber(row.fee), 0);
        return base + extra;
    };

    // Handle input change
    const handleFeeChange = (index, field, value) => {
        const newInstallments = [...installments];
        newInstallments[index][field] = value;
        setInstallments(newInstallments);
    };

    // Add new installment
    const handleAdd = () => {
        setInstallments([...installments, { fee: "", date: "" }]);
    };

    // Remove installment
    const handleRemove = (index) => {
        const newInstallments = installments.filter((_, i) => i !== index);
        setInstallments(newInstallments);
    };

    const updateFeeComponent = (index, field, value) => {
        setFeeComponents((prev) => {
            const next = [...prev];
            next[index] = { ...next[index], [field]: value };
            return next;
        });
    };
    const addFeeComponent = () => {
        setFeeComponents((prev) => [...prev, { name: "", fee: "" }]);
    };
    const removeFeeComponent = (index) => {
        setFeeComponents((prev) => prev.filter((_, i) => i !== index));
    };

    const validationSchema = Yup.object().shape({
        classId: Yup.string().required("Class Name is required"),
        sectionId: Yup.string(),
        studentId: Yup.array().when("isEventForAllStudent", {
            is: false,
            then: (schema) => schema.min(1, "Student Name is required"),
            otherwise: (schema) => schema,
        }),
        totalFee: Yup.string().required("Total Fee is required"),
        academicYearId: Yup.string().required("Academic Year is required"),
        isEventForAllStudent: Yup.boolean(),
        installments: Yup.array().of(
            Yup.object().shape({
                fee: Yup.string().required("Installment Fee is required"),
                date: Yup.string().required("Date is required"),
            })
        ),
    });
    useEffect(() => {
        // getStudentList();
        getFeeList();
        getAddClassList();
        getAcademicYearList();
        return () => {
            setTeacherIdList([]);
            setTeacherList([]);
            setAddClassList([]);
            setAcademicYearList([]);
            setStudentList([]);
            setFeeList([]);
            setFormSectionList([]);
            // setClassNameList([]);
        }
    }, []);
    const getStudentList = (classId, sectionId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        if (!classId) {
            setStudentList([]);
            return;
        }
        const getSpeList = { classId };
        if (sectionId) {
            getSpeList.sectionId = sectionId;
        }
        StudentService.getAllStudentById(userDetails.schooleId,
            getSpeList
        ).then((res) => {
            const studentDetails = res.map(res => {

                return { _id: res._id, studentName: `${res.firstName} ${res.lastName}`, status: true };
            })
            setStudentList(studentDetails);

        }).catch((err) => {
            // setError(err.message);
        });
    }

    const getSectionListByClass = (classId, target = "form") => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        if (!classId) {
            if (target === "filter") {
                setFilterSectionList([]);
            } else {
                setFormSectionList([]);
            }
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId,
        }).then((res) => {
            const list = Array.isArray(res) ? res : [];
            if (target === "filter") {
                setFilterSectionList(list);
            } else {
                setFormSectionList(list);
            }
        }).catch(() => {
            if (target === "filter") {
                setFilterSectionList([]);
            } else {
                setFormSectionList([]);
            }
        });
    };

    const onFilterClassChange = (event) => {
        const classId = event.target.value;
        setFilterClassId(classId);
        setFilterSectionId("");
        setFilterStudentId("");
        setFilterStudentList([]);
        setpg(0);
        getSectionListByClass(classId, "filter");
        if (classId) {
            loadFilterStudents(classId, "");
        }
    };

    const onFilterSectionChange = (event) => {
        const sectionId = event.target.value;
        setFilterSectionId(sectionId);
        setFilterStudentId("");
        setpg(0);
        loadFilterStudents(filterClassId, sectionId);
    };

    const onFilterStudentChange = (event) => {
        setFilterStudentId(event.target.value);
        setpg(0);
    };

    const loadFilterStudents = (classId, sectionId) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        if (!classId) {
            setFilterStudentList([]);
            return;
        }
        const query = { classId };
        if (sectionId) {
            query.sectionId = sectionId;
        }
        StudentService.getAllStudentById(userDetails.schooleId, query)
            .then((res) => {
                const list = Array.isArray(res) ? res : [];
                setFilterStudentList(
                    list.map((s) => ({
                        _id: s._id,
                        studentName: `${s.firstName || ""} ${s.lastName || ""}`.trim(),
                    }))
                );
            })
            .catch(() => setFilterStudentList([]));
    };

    const resetFilters = () => {
        setFilterClassId("");
        setFilterSectionId("");
        setFilterStudentId("");
        setFilterSectionList([]);
        setFilterStudentList([]);
        setpg(0);
    };

    const getFeeSectionLabel = (feeRow) => {
        const section =
            feeRow?.sectionId?.sectionName
            || feeRow?.studentId?.sectionId?.sectionName
            || "";
        return section || "All";
    };

    const filteredFeeList = useMemo(() => {
        return (feeList || []).filter((fee) => {
            const feeClassId = String(fee?.classId?._id || fee?.classId || "");
            const feeSectionId = String(
                fee?.sectionId?._id
                || fee?.sectionId
                || fee?.studentId?.sectionId?._id
                || fee?.studentId?.sectionId
                || ""
            );
            const feeStudentId = String(fee?.studentId?._id || fee?.studentId || "");

            if (filterClassId && feeClassId !== String(filterClassId)) {
                return false;
            }
            if (filterSectionId && feeSectionId !== String(filterSectionId)) {
                return false;
            }
            if (filterStudentId && feeStudentId !== String(filterStudentId)) {
                return false;
            }
            return true;
        });
    }, [feeList, filterClassId, filterSectionId, filterStudentId]);

    const updateInstallmentStatus = (feeId, installmentId, paymentStatus) => {
        if (!installmentId) return;
        setUpdatingInstallmentId(installmentId);
        FeeService.updateInstallmentPaymentStatus(installmentId, paymentStatus)
            .then(() => {
                setFeeList((prev) =>
                    (prev || []).map((feeRow) => {
                        if (String(feeRow._id) !== String(feeId)) return feeRow;
                        return {
                            ...feeRow,
                            istallmentId: (feeRow.istallmentId || []).map((inst) =>
                                String(inst._id) === String(installmentId)
                                    ? { ...inst, paymentStatus }
                                    : inst
                            ),
                        };
                    })
                );
            })
            .catch((err) => {
                alert(err.response?.data?.message || "Failed to update installment status");
            })
            .finally(() => {
                setUpdatingInstallmentId(null);
            });
    };

    const handleOpen = (status) => {
        if (status) {
            setFee({
                studentId: [],
                date: '',
                totalFee: '',
                tuitionFee: '',
                transportationFee: '',
                foodFee: '',
                appFee: '',
                feeComponents: [],
                classId: '',
                sectionId: '',
                academicYearId: '',
                installmentFee: '',
                isEventForAllStudent: false,

            })
            setFeeComponents([{ name: "", fee: "" }]);
            setInstallments([{ fee: "", date: "" }]);
            setFormSectionList([]);
            setStudentList([]);
        }

        setOpen(true);
    };
    const onclick = () => {
        setOpen(true);
    }
    const handleClose = () => {
        if (submitLoading) return;
        setOpen(false);
        setSubmitLoading(false);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };
    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }
    const dateAndTime = (date) => {

        const systemDate = new Date(date);
        const formattedDateTime = systemDate.toLocaleString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            // hour: 'numeric',
            // minute: 'numeric',
            // second: 'numeric',
            // hour12: true,

        });
        return formattedDateTime;
    }
    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }
    const onSubmit = data => {
        console.log(JSON.stringify(data, null, 2));
    };
    const getFeeList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        FeeService.getAllFee(userDetails.schooleId).then((res) => {
            // For debugging
            console.log('Fee List:', res);
            res.forEach(fee => {
                if (fee.academicYearId) {
                    console.log('Academic Year:', fee.academicYearId.acadamicYear);
                }
            });
            setFeeList(res);
        }).catch((err) => {
            console.error('Error fetching fees:', err);
        });
    }
    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            setAddClassList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getAcademicYearList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        AcademicYearService.getAllAcademicYear(userDetails.schooleId).then((res) => {
            const list = Array.isArray(res) ? res : [];
            // Backward-compatible: records created before `status` existed are treated as Active
            const activeOnly = list.filter((fm) => (fm.status || "Active") === "Active");
            setAcademicYearList(activeOnly);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const editFee = (fee, status) => {
        const obj = JSON.parse(JSON.stringify(fee));

        obj.academicYearId = fee.academicYearId && fee.academicYearId._id ? fee.academicYearId._id : '';

        // Set studentId
        obj.studentId = fee.studentId
            ? [fee.studentId._id]   // ✅ wrap in array
            : [];

        // Set classId
        obj.classId = fee.classId ? fee.classId._id : '';

        // Set sectionId
        obj.sectionId = fee.sectionId
            ? (fee.sectionId._id || fee.sectionId)
            : '';

        // Set installments
        obj.installments = fee.istallmentId ? fee.istallmentId.map(inst => ({
            fee: inst.installmentFee,
            date: inst.installmentdate ? inst.installmentdate.split("T")[0] : ""
        })) : [{ fee: "", date: "" }];
        setInstallments(obj.installments);
        // ✅ Fix date format for date input
        if (fee.date) {
            obj.date = new Date(fee.date).toISOString().split("T")[0];
        }

        getSectionListByClass(obj.classId, "form");
        getStudentList(obj.classId, obj.sectionId);
        getAddClassList();
        getAcademicYearList(); // Add this line to fetch academic years

        obj.tuitionFee = fee.tuitionFee != null ? String(fee.tuitionFee) : "";
        obj.transportationFee = fee.transportationFee != null ? String(fee.transportationFee) : "";
        obj.foodFee = fee.foodFee != null ? String(fee.foodFee) : "";
        obj.appFee = fee.appFee != null ? String(fee.appFee) : "";
        const comps = Array.isArray(fee.feeComponents) ? fee.feeComponents : [];
        setFeeComponents(
            comps.length
                ? comps.map((r) => ({
                    name: r.name || "",
                    fee:
                        r.fee != null
                            ? String((r.operation === "-" ? -1 : 1) * Number(r.fee))
                            : "",
                }))
                : [{ name: "", fee: "" }]
        );

        setFee(obj);
        if (status) {
            delete obj._id;
        }
        handleOpen(false);
    };

    const openDeleteConfirm = (feeRow) => {
        if (!feeRow) return;
        setDeleteConfirm({ open: true, row: feeRow });
    };

    const closeDeleteConfirm = () => {
        if (deleteLoading) return;
        setDeleteConfirm({ open: false, row: null });
    };

    const confirmDeleteFee = () => {
        const feedelete = deleteConfirm.row;
        if (!feedelete?._id) return;
        setDeleteLoading(true);
        FeeService.deleteFee(feedelete)
            .then(() => {
                setDeleteConfirm({ open: false, row: null });
                setDeleteLoading(false);
                getFeeList();
            })
            .catch(() => {
                setDeleteLoading(false);
            });
    };
    const formik = useFormik({
        initialValues: fee,


        enableReinitialize: true,
        validationSchema: validationSchema,

        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.schooleId = userDetails.schooleId;
            values.installments = installments;
            values.feeComponents = (feeComponents || [])
                .filter((r) => r && String(r.name || "").trim() !== "")
                .map((r) => ({
                    name: String(r.name || "").trim(),
                    operation: toNumber(r.fee) < 0 ? "-" : "+",
                    fee: Math.abs(toNumber(r.fee)),
                }));
            values.totalFee = String(computeTotalFee(values, values.feeComponents));
            values.sectionId = values.sectionId && String(values.sectionId).trim() !== ''
                ? values.sectionId
                : null;

            if (values.isEventForAllStudent) {
                const duplicateMsg = getClassSectionWiseDuplicateMessage(feeList, {
                    academicYearId: values.academicYearId,
                    classId: values.classId,
                    sectionId: values.sectionId,
                    // Only enforce on create; edit keeps existing student fee row.
                    excludeId: fee._id,
                });
                if (duplicateMsg && !fee._id) {
                    alert(duplicateMsg);
                    return;
                }
            }

            setSubmitLoading(true);
            if (fee._id) {
                values._id = fee._id;
                FeeService.upadeFee(values).then((res) => {
                    handleClose();
                    getFeeList();
                    resetForm()
                    setInstallments([{ fee: "", date: "" }]);
                    alert("Fee Updated Successfully.");
                }).catch((err) => {
                    alert(err.response?.data?.message || "Error updating fee");
                }).finally(() => {
                    setSubmitLoading(false);
                });
            }
            else {
                FeeService.creteFee(values).then((res) => {
                    // Immediately refresh the list
                    getFeeList();
                    // Reset form data
                    resetForm();
                    // Reset installments if you're using them separately
                    setInstallments([{ fee: '', date: '' }]);
                    handleClose();
                    alert("Fee Added Successfully.");
                })
                    .catch((err) => {
                        alert(err.response?.data?.message || "Error adding fee");
                    })
                    .finally(() => {
                        setSubmitLoading(false);
                    });
            }

        },
    });

    useEffect(() => {
        const nextTotal = String(computeTotalFee(formik.values, feeComponents));
        if (formik.values.totalFee !== nextTotal) {
            formik.setFieldValue("totalFee", nextTotal, false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formik.values.tuitionFee,
        formik.values.transportationFee,
        formik.values.foodFee,
        formik.values.appFee,
        feeComponents,
    ]);
    const totalInstallments = installments.reduce(
        (sum, inst) => sum + Number(inst.fee || 0),
        0
    );
    return (

        <>
            {/* Page-local header (instead of shared PageTitle) so the button wraps under the
                title on phones rather than overlapping it. */}
            <Box className={classes.pageHeader}>
                <Typography variant="h1" size="sm" className={classes.pageHeaderTitle}>
                    Fee
                </Typography>
                <Button
                    variant="contained"
                    onClick={() => handleOpen(true)}
                    size="medium"
                    color="secondary"
                    className={classes.pageHeaderButton}
                    style={{ backgroundColor: 'rgb(15 59 98)' }}
                >
                    Set up fee structure
                </Button>
            </Box>
            <Card className={classes.statusInstructionCard} elevation={0}>
                <Box className={classes.statusInstructionIconWrap}>
                    <InfoOutlinedIcon fontSize="small" />
                </Box>
                <Box style={{ flex: 1, minWidth: 0 }}>
                    <Typography
                        variant="subtitle2"
                        style={{ color: "#0f3b62", fontWeight: 700, marginBottom: 6 }}
                    >
                        Installment payment status instruction
                    </Typography>
                    <Typography variant="body2" style={{ color: "#334155", lineHeight: 1.6 }}>
                        By default, the payment status for each installment is set to{" "}
                        <span className={classes.statusBadgeDue}>
                            <ScheduleIcon style={{ fontSize: 14 }} />
                            Due
                        </span>
                        . Once an installment payment is received, change the status in the
                        Installment Fee column from{" "}
                        <span className={classes.statusBadgeDue}>
                            <ScheduleIcon style={{ fontSize: 14 }} />
                            Due
                        </span>
                        {" "}to{" "}
                        <span className={classes.statusBadgePaid}>
                            <CheckCircleOutlineIcon style={{ fontSize: 14 }} />
                            Paid
                        </span>
                        .
                    </Typography>
                    <Box className={classes.parentAppHint}>
                        <PhoneAndroidIcon style={{ fontSize: 16 }} />
                        This status update is reflected automatically in the Parent Mobile App.
                    </Box>
                </Box>
            </Card>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Card style={{ padding: 16, marginBottom: 16 }}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={6} md={3}>
                                <FormControl fullWidth>
                                    <InputLabel id="fee-filter-class-label" shrink>
                                        Filter Class
                                    </InputLabel>
                                    <Select
                                        labelId="fee-filter-class-label"
                                        value={filterClassId}
                                        onChange={onFilterClassChange}
                                        displayEmpty
                                    >
                                        <MenuItem value="">
                                            <em>All Classes</em>
                                        </MenuItem>
                                        {addClassList.map(({ _id, className }) => (
                                            <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <FormControl fullWidth disabled={!filterClassId || filterSectionList.length === 0}>
                                    <InputLabel id="fee-filter-section-label" shrink>
                                        Filter Section
                                    </InputLabel>
                                    <Select
                                        labelId="fee-filter-section-label"
                                        value={filterSectionId}
                                        onChange={onFilterSectionChange}
                                        displayEmpty
                                    >
                                        <MenuItem value="">
                                            <em>All Sections</em>
                                        </MenuItem>
                                        {filterSectionList.map(({ _id, sectionName }) => (
                                            <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <FormControl fullWidth disabled={!filterClassId}>
                                    <InputLabel id="fee-filter-student-label" shrink>
                                        Filter Student Name
                                    </InputLabel>
                                    <Select
                                        labelId="fee-filter-student-label"
                                        value={filterStudentId}
                                        onChange={onFilterStudentChange}
                                        displayEmpty
                                    >
                                        <MenuItem value="">
                                            <em>All Students</em>
                                        </MenuItem>
                                        {filterStudentList.map(({ _id, studentName }) => (
                                            <MenuItem key={_id} value={_id}>{studentName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <Button
                                    variant="outlined"
                                    onClick={resetFilters}
                                    disabled={!filterClassId && !filterSectionId && !filterStudentId}
                                >
                                    Clear Filters
                                </Button>
                            </Grid>
                        </Grid>
                    </Card>
                   
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                        <TableContainer component={Paper} style={{ maxHeight: 500 }}>

                            <Table stickyHeader className="mb-0 dashboard-table-row-hover">
                                <TableHead >
                                    <TableRow>
                                        {tableHeaders.map(key => (
                                            <StyledTableCell key={key}>{key}</StyledTableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>




                                    {filteredFeeList.slice(pg * rpg, pg * rpg + rpg).map((fee) => (
                                        <TableRow key={fee._id}>
                                            <TableCell className="pl-3 fw-normal" >
                                                {fee.academicYearId && typeof fee.academicYearId === 'object'
                                                    ? fee.academicYearId.acadamicYear
                                                    : (fee.academicYear || '')}
                                            </TableCell>

                                            <TableCell className="pl-3 fw-normal" >{fee.classId ? fee.classId.className : ''}</TableCell>
                                            <TableCell className="pl-3 fw-normal">{getFeeSectionLabel(fee)}</TableCell>

                                            <TableCell>
                                                {fee.studentId
                                                    ? `${fee.studentId.firstName} ${fee.studentId.lastName}`
                                                    : "All"}
                                            </TableCell>
                                            <TableCell className="pl-3 fw-normal" >{fee.totalFee}</TableCell>
                                            <TableCell>
                                                {Array.isArray(fee.feeComponents) && fee.feeComponents.length > 0 ? (
                                                    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                                        {fee.feeComponents.map((c, idx) => (
                                                            <div key={idx} style={{ whiteSpace: "nowrap" }}>
                                                                {c.name} - ₹{Math.abs(Number(c.fee || 0))}
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    "-"
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {fee.istallmentId && fee.istallmentId.length > 0 ? (
                                                    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                                        {fee.istallmentId.map((inst) => {
                                                            const status = normalizeInstallmentStatus(inst.paymentStatus);
                                                            const isUpdating = updatingInstallmentId === inst._id;
                                                            return (
                                                                <div
                                                                    key={inst._id || `${inst.installmentdate}-${inst.installmentFee}`}
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: 8,
                                                                        whiteSpace: "nowrap",
                                                                    }}
                                                                >
                                                                    <span>
                                                                        {dateAndTime(inst.installmentdate)} - ₹{inst.installmentFee}
                                                                    </span>
                                                                    <FormControl size="small" style={{ minWidth: 90 }}>
                                                                        <Select
                                                                            value={status}
                                                                            disabled={!inst._id || isUpdating}
                                                                            onChange={(e) =>
                                                                                updateInstallmentStatus(
                                                                                    fee._id,
                                                                                    inst._id,
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            style={{
                                                                                fontSize: 12,
                                                                                color: status === "Paid" ? "#15803d" : "#b91c1c",
                                                                                fontWeight: 600,
                                                                            }}
                                                                        >
                                                                            <MenuItem value="Due">Due</MenuItem>
                                                                            <MenuItem value="Paid">Paid</MenuItem>
                                                                        </Select>
                                                                    </FormControl>
                                                                    {isUpdating && <CircularProgress size={14} />}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                ) : (
                                                    "-"
                                                )}
                                            </TableCell>

                                            <TableCell>
                                                <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                                                    <EditIcon
                                                        style={{ cursor: 'pointer', color: '#0f3b62' }}
                                                        onClick={() => editFee(fee)}
                                                    />
                                                    <DeleteIcon
                                                        style={{ cursor: 'pointer', color: '#b91c1c' }}
                                                        onClick={() => openDeleteConfirm(fee)}
                                                    />
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[1000, 10000, 100000]}
                            count={filteredFeeList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            <Dialog
                open={open}
                onClose={handleClose}
                disableEscapeKeyDown={submitLoading}
                scroll="paper"
                // Full-screen on phones; the fixed 500px width overflowed narrow screens.
                fullScreen={isPhone}
                PaperProps={{
                    style: isPhone
                        ? { overflow: 'hidden' }
                        : {
                            width: '500px',
                            maxWidth: '100%',
                            margin: '0 auto',
                            maxHeight: '80vh',
                            overflow: 'hidden'
                        }
                }}>
                <DialogTitle>Set up fee structure</DialogTitle>
                <form
                    onSubmit={formik.handleSubmit}
                    style={isPhone ? { display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 } : undefined}
                >
                    <DialogContent
                        style={{
                            maxHeight: isPhone ? 'none' : '60vh',
                            flex: isPhone ? 1 : undefined,
                            overflowY: 'auto',
                            width: '100%',
                            boxSizing: 'border-box',
                        }}
                    >
                        {submitLoading && (
                            <Box style={{ marginBottom: 16 }}>
                                <LinearProgress style={{ marginBottom: 10 }} />
                                <Typography
                                    variant="body2"
                                    style={{
                                        color: '#0f3b62',
                                        fontWeight: 600,
                                        textAlign: 'center',
                                        lineHeight: 1.4,
                                    }}
                                >
                                    Please wait until all students are added. Do not press any button.
                                </Typography>
                            </Box>
                        )}

                        <FormControl className={classes.formControl} fullWidth="true"
                        >
                            <InputLabel id="demo-simple-select-label">Select Acadamic Year</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="academicYearId"
                                label="Select Acadamic Year"
                                value={formik.values.academicYearId}
                                onChange={formik.handleChange}
                                error={formik.touched.academicYearId && Boolean(formik.errors.academicYearId)}
                                helperText={formik.touched.academicYearId && formik.errors.academicYearId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>

                                {academicYearList.map((year) => (
                                    <MenuItem key={year._id} value={year._id}>
                                        {year.acadamicYear}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl} fullWidth="true"
                        >
                            <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="classId"
                                label="selectClass"

                                value={formik.values.classId}
                                onChange={e => {
                                    const classId = e.target.value;
                                    formik.handleChange(e);
                                    formik.setFieldValue('sectionId', '');
                                    formik.setFieldValue('studentId', []);
                                    getSectionListByClass(classId, "form");
                                    getStudentList(classId, '');
                                }}
                                // onChange={formik.handleChange}

                                error={formik.touched.classId && Boolean(formik.errors.classId)}
                                helperText={formik.touched.classId && formik.errors.classId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>

                                {addClassList.map(({ _id, className }) => (
                                    <MenuItem key={_id} value={_id}>{className}

                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl
                            className={classes.formControl}
                            fullWidth="true"
                            disabled={!formik.values.classId || formSectionList.length === 0}
                        >
                            <InputLabel id="fee-form-section-label" shrink>
                                Select Section (Optional)
                            </InputLabel>
                            <Select
                                labelId="fee-form-section-label"
                                id="fee-form-section-select"
                                name="sectionId"
                                label="Select Section (Optional)"
                                displayEmpty
                                value={formik.values.sectionId || ''}
                                onChange={e => {
                                    const sectionId = e.target.value;
                                    formik.setFieldValue('sectionId', sectionId);
                                    formik.setFieldValue('studentId', []);
                                    getStudentList(formik.values.classId, sectionId);
                                }}
                            >
                                <MenuItem value="">
                                    <em>All Sections</em>
                                </MenuItem>
                                {formSectionList.map(({ _id, sectionName }) => (
                                    <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <div>

                            {formik.values.isEventForAllStudent}
                            <Grid item xs={12} sm={12} md={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox name="isEventForAllStudent" id="terms"
                                            value={formik.values.isEventForAllStudent}
                                            checked={formik.values.isEventForAllStudent}
                                            onChange={formik.handleChange}
                                            error={formik.touched.isEventForAllStudent && Boolean(formik.errors.isEventForAllStudent)}
                                            helperText={formik.touched.isEventForAllStudent && formik.errors.isEventForAllStudent}
                                        />
                                    }
                                    label="For All Class Students"
                                />
                            </Grid>

                            <Grid item xs={12} style={{ marginTop: '30px' }}>
                                <span style={{ fontSize: '17px', color: '#0f3b62ad', }} >Any Concession For Special Student:</span>
                            </Grid>
                        </div>
                        <FormControl
                            variant="standard"
                            fullWidth
                            disabled={formik.values.isEventForAllStudent}
                            error={formik.touched.studentId && Boolean(formik.errors.studentId)}
                        >
                            <InputLabel id="studentName-label">Student Name *</InputLabel>
                            <Select
                                labelId="studentName-label"
                                id="studentName-select"
                                label="Student Name"
                                name="studentId"
                                multiple
                                value={formik.values.studentId} // make sure this is an array in Formik's initialValues
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                // Customize how the selected values are displayed in the input
                                renderValue={(selected) => {
                                    // Find student names for the selected IDs
                                    const selectedNames = studentList
                                        .filter(({ _id }) => selected.includes(_id))
                                        .map(({ studentName }) => studentName);
                                    return selectedNames.join(", ");
                                }}
                            >
                                {studentList.map(({ _id, studentName }) => (
                                    <MenuItem key={_id} value={_id}>
                                        {studentName}
                                    </MenuItem>
                                ))}
                            </Select>
                            {formik.touched.studentId && formik.errors.studentId && (
                                <Typography variant="caption" color="error" style={{ marginTop: 4 }}>
                                    {formik.errors.studentId}
                                </Typography>
                            )}
                        </FormControl>
                        <Typography style={{ marginTop: 24, marginBottom: 8, fontWeight: 600 }}>
                            Fee breakdown
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Tuition fee"
                                    name="tuitionFee"
                                    value={formik.values.tuitionFee}
                                    onChange={formik.handleChange}
                                    type="number"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Transportation fee"
                                    name="transportationFee"
                                    value={formik.values.transportationFee}
                                    onChange={formik.handleChange}
                                    type="number"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Food fee"
                                    name="foodFee"
                                    value={formik.values.foodFee}
                                    onChange={formik.handleChange}
                                    type="number"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="App fee"
                                    name="appFee"
                                    value={formik.values.appFee}
                                    onChange={formik.handleChange}
                                    type="number"
                                    fullWidth
                                />
                            </Grid>
                        </Grid>

                        <Typography style={{ marginTop: 18, marginBottom: 8, fontWeight: 600 }}>
                            Additional fee components
                        </Typography>
                        {feeComponents.map((row, index) => (
                            <Grid container spacing={2} alignItems="center" key={index} style={{ marginBottom: 8 }}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="Name"
                                        value={row.name}
                                        onChange={(e) => updateFeeComponent(index, "name", e.target.value)}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <TextField
                                        label="Fee (+ add / - subtract)"
                                        value={row.fee}
                                        onChange={(e) => updateFeeComponent(index, "fee", e.target.value)}
                                        type="number"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={1} style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                                    <IconButton
                                        onClick={addFeeComponent}
                                        size="small"
                                        style={{ backgroundColor: "#e3f2fd", width: 32, height: 32 }}
                                    >
                                        <Add fontSize="small" />
                                    </IconButton>
                                    {feeComponents.length > 1 && (
                                        <IconButton
                                            onClick={() => removeFeeComponent(index)}
                                            size="small"
                                            style={{ backgroundColor: "#ffebee", width: 32, height: 32 }}
                                        >
                                            <Remove fontSize="small" />
                                        </IconButton>
                                    )}
                                </Grid>
                            </Grid>
                        ))}

                        <TextField
                            fullWidth="true"
                            margin="dense"
                            id="totalFee"
                            name="totalFee"
                            label="Total Fee"
                            type="text"
                            variant="standard"
                            value={formik.values.totalFee}
                            disabled
                        />
                        {/* <TextField
                            InputProps={{ style: { width: 258 } }}
                            margin="dense"
                            id="installmentFee"
                            name="installmentFee"
                            label="Installment Fee"
                            type="text"
                            variant="standard"
                            value={formik.values.installmentFee}
                            onChange={formik.handleChange}
                            error={formik.touched.installmentFee && Boolean(formik.errors.installmentFee)}
                            helperText={formik.touched.installmentFee && formik.errors.installmentFee}
                        />
                        <TextField InputProps={{ style: { width: 250 } }}
                            id="date"
                            name="date"
                            label="Select Date"
                            type="date"
                            value={formik.values.date}
                            onChange={formik.handleChange}
                            error={formik.touched.date && Boolean(formik.errors.date)}
                            helperText={formik.touched.date && formik.errors.date}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        /> */}

                        <Typography style={{ marginTop: 24, marginBottom: 8, fontWeight: 600 }}>Installments</Typography>
                        {installments.map((installment, index) => (
                            <Grid
                                container
                                spacing={2}
                                alignItems="center"
                                key={index}
                                style={{
                                    marginBottom: 10,
                                    width: '100%',
                                    margin: 0,
                                    paddingRight: '16px'
                                }}
                            >
                                <Grid item xs={12} sm={5}>
                                    <TextField
                                        label={`${index + 1}${getOrdinalSuffix(index + 1)} Instalment Fee`}
                                        value={installment.fee}
                                        onChange={(e) =>
                                            handleFeeChange(index, "fee", e.target.value)
                                        }
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <SchoolDatePicker
                                        label="Due date"
                                        value={installment.date}
                                        onChange={(iso) => handleFeeChange(index, "date", iso)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={2} style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', alignItems: 'center' }}>
                                    <IconButton
                                        color="primary"
                                        onClick={handleAdd}
                                        size="small"
                                        style={{
                                            backgroundColor: "#e3f2fd",
                                            width: '32px',
                                            height: '32px',
                                            padding: '4px'
                                        }}>
                                        <Add fontSize="small" />
                                    </IconButton>
                                    {installments.length > 1 && (
                                        <IconButton
                                            color="secondary"
                                            onClick={() => handleRemove(index)}
                                            size="small"
                                            style={{
                                                backgroundColor: "#ffebee",
                                                width: '32px',
                                                height: '32px',
                                                padding: '4px'
                                            }}
                                        >
                                            <Remove fontSize="small" />
                                        </IconButton>
                                    )}
                                </Grid>
                            </Grid>
                        ))}
                        <Typography
                            variant="subtitle1"
                            style={{ marginTop: 16, fontWeight: "bold" }}
                        >
                            Total Fee Payable: {installments.reduce((sum, inst) => sum + Number(inst.fee || 0), 0)}
                        </Typography>
                        {totalInstallments !== Number(formik.values.totalFee) && (
                            <Typography color="error" variant="body2" style={{ marginTop: 4 }}>
                                ⚠️ Installments don’t match Total Fee ({totalInstallments} / {formik.values.totalFee})
                            </Typography>
                        )}
                    </DialogContent>

                    <DialogActions style={{ 
                        position: 'sticky', 
                        bottom: 0, 
                        background: '#fff', 
                        borderTop: '1px solid #eee',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '12px',
                        padding: '16px 24px'
                    }}>
                        <Button onClick={handleClose} disabled={submitLoading}>Cancel</Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={submitLoading}
                            startIcon={submitLoading ? <CircularProgress size={16} color="inherit" /> : null}
                        >
                            {submitLoading
                                ? (fee._id ? "Updating..." : "Adding...")
                                : (fee._id ? "Update" : "Add")}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                open={deleteConfirm.open}
                onClose={closeDeleteConfirm}
                scroll="paper"
                PaperProps={{ className: classes.deleteDialogPaper }}
            >
                <Box className={classes.deleteDialogTitleBar}>
                    <span className={classes.deleteDialogTitleText}>Delete fee?</span>
                    <IconButton size="small" onClick={closeDeleteConfirm} disabled={deleteLoading}>
                        <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
                <DialogContent className={classes.deleteDialogBody}>
                    <Typography className={classes.deleteConfirmText}>
                        Are you sure you want to delete this fee for{" "}
                        <strong>
                            {deleteConfirm.row?.studentId
                                ? `${deleteConfirm.row.studentId.firstName || ""} ${deleteConfirm.row.studentId.lastName || ""}`.trim()
                                : "all students"}
                        </strong>
                        {deleteConfirm.row?.classId?.className
                            ? ` (${deleteConfirm.row.classId.className}${getFeeSectionLabel(deleteConfirm.row) && getFeeSectionLabel(deleteConfirm.row) !== "All" ? ` · ${getFeeSectionLabel(deleteConfirm.row)}` : ""})`
                            : ""}
                        {deleteConfirm.row?.totalFee ? ` — ₹${deleteConfirm.row.totalFee}` : ""}?
                    </Typography>
                    <Typography className={classes.deleteConfirmText} style={{ marginTop: 12, color: '#c62828' }}>
                        This action cannot be undone.
                    </Typography>
                </DialogContent>
                <DialogActions className={classes.deleteDialogFooter}>
                    <Button onClick={closeDeleteConfirm} className={classes.deleteCancelBtn} disabled={deleteLoading}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        className={classes.deleteConfirmBtn}
                        onClick={confirmDeleteFee}
                        disabled={deleteLoading}
                    >
                        {deleteLoading ? "Deleting…" : "Delete"}
                    </Button>
                </DialogActions>
            </Dialog>
            {/* <Table>
      <TableHead>
        <TableRow>
          <TableCell>Installment #</TableCell>
          <TableCell>Fee</TableCell>
          <TableCell>Date</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {savedInstallments.map((inst, i) => (
          <TableRow key={i}>
            <TableCell>{i + 1}</TableCell>
            <TableCell>{inst.fee}</TableCell>
            <TableCell>{inst.date}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table> */}

        </>
    );
}


